import React from "react";
import ActionApprovalCard from "../ActionApprovalCard";
import { extractApprovalEnvelope, extractExecutedToolResult } from "./approvalEnvelope";
import { resolveScopeBaseline } from "../scopeChangeDiff";
import {
  buildSpecializedToolCardContext,
  renderSpecializedToolCard,
} from "../renderSpecializedToolCard";

/**
 * Renders a gated tool part as an inline approval card (and post-approve tool output when present).
 */
export function renderApprovalToolPart({
  partKey,
  toolName,
  inputStr,
  resultStr,
  approvalEnvelope,
  agentName,
  agentId,
  grouped,
  chatSessionId,
  currentEnabledTools,
  currentAgentScopeById,
  messages,
  onResolveActionApproval,
  onSubmitAskHumanAnswer,
  onSubmitCredentialSetup,
  onOpenAgentSettings,
  onOpenDynamicForm,
  onOpenCreatedFile,
  respondedCorrelationIds,
  scheduledMessages,
  onEditScheduledMessage,
  onCancelScheduledMessage,
  onRefreshScheduledMessages,
  compactToolCalls,
  workerStatusMap,
  messageTimestamp = null,
  parsedInput = null,
}) {
  const approvalStatus = approvalEnvelope.status || "PENDING";
  const currentAgentScope = resolveScopeBaseline({
    agentId,
    currentAgentScopeById,
    messages,
  });
  const elements = [
    <ActionApprovalCard
      key={`${partKey}-approval`}
      args={inputStr}
      parsedInput={parsedInput}
      result={resultStr}
      agentName={agentName}
      agentId={agentId}
      grouped={grouped}
      chatSessionId={chatSessionId}
      currentEnabledTools={currentEnabledTools}
      currentAgentScope={currentAgentScope}
      onResolve={onResolveActionApproval}
      onOpenAgentSettings={onOpenAgentSettings}
    />,
  ];

  if (approvalStatus === "APPROVED") {
    const executedResult = extractExecutedToolResult(approvalEnvelope);
    if (executedResult != null) {
      elements.push(
        renderSpecializedToolCard(
          buildSpecializedToolCardContext({
            partKey: `${partKey}-tool`,
            toolName,
            inputStr,
            resultStr: executedResult,
            parsedInput,
            parsedOutput: approvalEnvelope.executedResult ?? null,
            lifecycleState: "output-available",
            grouped: true,
            typedMessage: { timestamp: messageTimestamp },
            opts: {
              agentName,
              agentId,
              chatSessionId,
              onOpenAgentSettings,
              onOpenDynamicForm,
              onOpenCreatedFile,
              respondedCorrelationIds,
              scheduledMessages,
              onEditScheduledMessage,
              onCancelScheduledMessage,
              onRefreshScheduledMessages,
              compactToolCalls,
              workerStatusMap,
              onSubmitAskHumanAnswer,
              onSubmitCredentialSetup,
            },
          })
        )
      );
    }
  }

  return elements;
}

export { extractApprovalEnvelope };
